import * as React from 'react';
import { Element as ReactScrollElement } from 'react-scroll';

import { getModeClass } from 'utils/css';
import { SUB_CONTENT_SCROLL_ELEMENT } from '../content.constants';
import GameLogo from '../../game-logo';
import { IContent } from '../content.types';

const ContentView: React.FC<Pick<IContent, 'shouldInheritStyles' | 'children'>> = ({
    shouldInheritStyles,
    children
}) => (
    <div className={getModeClass('sitegen-content-wrapper', shouldInheritStyles)}>
        <div className={getModeClass('sitegen-content', shouldInheritStyles)}>
            {shouldInheritStyles ? null : <GameLogo />}

            <ReactScrollElement
                className={getModeClass('sitegen-sub-content', shouldInheritStyles)}
                name={SUB_CONTENT_SCROLL_ELEMENT}
            >
                {children}
            </ReactScrollElement>
        </div>
    </div>
);

export default ContentView;
